import React from 'react';

import {
  IFacialRecognitionProcess,
  TOnboardingType,
} from 'shared/domain/entities';
import { Animation } from 'shared/presentation/components/atoms';
import { Button } from 'shared/presentation/components/molecules';
import { ICONS, TIconType } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';
import { useEventTracker } from 'shared/presentation/hooks';

import * as S from './styles';
import facialAnimation from '../PendingStatus/assets/facial_recognition.json';

const ONBOARDING_ICON_DICTIONARY: Record<TOnboardingType, TIconType> = {
  DOCUMENTOSCOPY: ICONS.DOCUMENT,
  FACIAL_BIOMETRY: ICONS.FACE_SCAN,
  ONE_FOR_ONE_BIOMETRY: ICONS.FACE_SCAN,
};

interface ISetup {
  process: IFacialRecognitionProcess;
  availableOnboardings: TOnboardingType[];
  onGoToOnboarding(onboarding: TOnboardingType): void;
}

const Setup: React.FC<ISetup> = ({
  process,
  availableOnboardings,
  onGoToOnboarding,
}) => {
  const { t } = useLocale('shared');
  const tracker = useEventTracker();

  const ONBOARDING_BUTTON_TEXT_DICTIONARY: Record<TOnboardingType, string> = {
    DOCUMENTOSCOPY: t('Try with a recent document'),
    FACIAL_BIOMETRY: t('Try with selfie'),
    ONE_FOR_ONE_BIOMETRY: t('Try with selfie'),
  };

  return (
    <S.Container>
      <main>
        <div>
          <Animation
            loop
            animation={{
              data: facialAnimation,
              height: 150,
              width: 150,
            }}
          />
        </div>

        <section>
          <h1>{t('Facial recognition')}</h1>

          <p>{t('Please, choose how you want to identify yourself')}</p>
        </section>

        <footer>
          {availableOnboardings.map(onboarding => (
            <Button
              key={onboarding}
              icon={ONBOARDING_ICON_DICTIONARY[onboarding] || ICONS.REFRESH}
              onClick={() => {
                tracker.register('SELECT_INITIAL_ONBOARDING', {
                  data: process.trackingPayload,
                  onboarding,
                });

                onGoToOnboarding(onboarding);
              }}
              variant="primary"
            >
              {ONBOARDING_BUTTON_TEXT_DICTIONARY[onboarding]}
            </Button>
          ))}
        </footer>
      </main>
    </S.Container>
  );
};

export default Setup;
